<template>
  <div class="authentication">
    <!-- <real-name v-if=" type == 1 "></real-name> -->
    <advanced-certification v-if=" type == 2 "></advanced-certification>
    <index-page v-if="!type"></index-page>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { getterTypes } from '@/store/getter-types';
import IndexPage from './components/IndexPage/IndexPage';
// import RealName from './components/real-name/RealName';
import AdvancedCertification from './components/AdvancedCertification/AdvancedCertification';
import tool from '@/common/js/tool';
export default {
  name: 'authentication',
  components: {
    'index-page': IndexPage,
    // 'real-name': RealName,
    'advanced-certification': AdvancedCertification
  },
  provide() {
    return {
      step: this.step
    };
  },
  data() {
    return {
      step: null
    };
  },
  props: {},
  watch: {},
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    type() {
      return this.$route.query.type;
    }
  },
  created() {},
  mounted() {
    let obj = tool.urljson(window.location.href);
    this.step = obj.step;
  },
  destroyed() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
@import './authentication.styl';
</style>
